
















import { defineComponent, PropType } from '@vue/composition-api';
import { HtmlString } from '@front-app/services/SharedModels';
import { VueConstructor } from 'vue';
import SimpleCard from './SimpleCard.vue';

export default defineComponent({
	components: {
		SimpleCard,
	},
	props: {
		tag: {
			type: [String, Object] as PropType<null | string | VueConstructor>,
			default: () => SimpleCard,
		},
		termsAndConditionsHtml: {
			type: String as unknown as PropType<HtmlString>,
			default: '',
		},
	},
	setup() {
		return {};
	},
});
